/**
 * External dependencies
 */
import React, { useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Box } from '@towersystems/towersystems-design-system';


/**
 * Internal dependencies
 */
import Icon from 'components/icon';

/**
 * Style dependencies
 */
import './styles.scss';

const getIcon = ({ status }) => {
    let icon;
    switch (status) {
        case 'is-success':
            icon = 'FiCheck';
            break;
        case 'is-info':
        default:
            icon = 'FiInfo';
            break;
    }
    return icon;
};

const Notice = (props) => {
    //let dismissTimeout = null;

    useEffect(() => {
        if (props.duration > 0) {
           setTimeout(props.onDismissClick, props.duration);
        }
    }, []);

    const { children, text, showDismiss } = props;

    const classes = classNames('notice', props.status, props.className, {
        'is-dismissable': showDismiss,
    });

    const iconName = getIcon(props);
    
    return (
        <Box display="flex" alignItems="center" padding="large" className={classes}>
            <span className='notice__content'>
                <span className='notice__text'>{text ? text : children}</span>
            </span>
            {showDismiss && (
                <button className='notice__dismiss' onClick={props.onDismissClick} aria-label={'Dismiss'}>
                    <Icon name='FiX' size={24} />
                </button>
            )}
        </Box>
    );
};

Notice.defaultProps = {
    showDismiss: true,
    onDismissClick: noop,
    duration: 3500,
};

Notice.propTypes = {
    showDismiss: PropTypes.bool,
    onDismissClick: PropTypes.func,
    text: PropTypes.string,
};

export default Notice;
